import { Config } from "@config/config";
import ISelect from "@components/forms/ISelect";

import { useTranslation } from "react-i18next";
import Input from "@components/forms/Input";
import React from "react";

const FormSearch = (props) => {
  const { t } = useTranslation();
  const config = new Config(t);

  return (
    <div className="row">
      <div className="col-md-4">
        <Input
          id="searchText"
          name="searchText"
          type="text"
          placeholder={t("search_by_name")}
          value={props.selectInput}
          onChange={props.getSelectInput}
        />
      </div>
      <div className="col-md-3">
        <ISelect
          id="status"
          name="status"
          label={t("status")}
          value={props.selectedStatus}
          handleChange={props.setSelectedStatus}
          data={config.userStatusOptions()}
        />
      </div>
      <div className="col-md-5 d-flex align-items-center gap-2">
        <button
          className="w-100 p-button btn-blue mb-3"
          onClick={() => props.loadData(0)}
        >
          {t("search")}
        </button>
        <button
          className="w-100 p-button btn-secondary mb-3"
          onClick={() => props.reset(0)}
        >
          {t("clear_filters")}
        </button>
      </div>
    </div>
  );
};

export default FormSearch;
